import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";

import { finalize, map } from "rxjs/operators";
import { LogoutDialogComponent } from "src/modules/app/components/logout-dialog/logout-dialog.component";
import { fromPublications } from "src/modules/store/publications";
import { UserStateService } from "src/shared/services/user-state.service";

import { QuickSearchComponent } from "#modules/search-shared/components/quick-search/quick-search.component";
import { SharedModule } from "#modules/shared/shared.module";

import { SidenavStateService } from "../../../shared/services/sidenav-state.service";

@Component({
  selector: "app-top-nav",
  templateUrl: "./top-nav.component.html",
  styleUrls: ["./top-nav.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, QuickSearchComponent],
})
export class TopNavComponent {
  private readonly userStateService = inject(UserStateService);
  private readonly sidenavService = inject(SidenavStateService);
  private readonly dialogService = inject(MatDialog);
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  readonly loading = signal(false);

  readonly isAdmin$ = this.userStateService.isAdmin$;
  readonly isEditor$ = this.userStateService.isEditor$;
  readonly user$ = this.userStateService.user$;
  readonly isLoggedIn$ = this.userStateService.isLoggedIn$;
  readonly username$ = this.userStateService.user$.pipe(map((user) => user?.userName));
  readonly sideNavOpened = this.sidenavService.opened;

  readonly organization$ = this.store.select(fromPublications.selectValidatedOrgId);

  onLogout(e: Event) {
    this.loading.set(true);
    this.dialogService
      .open(LogoutDialogComponent)
      .afterClosed()
      .pipe(
        finalize(() => this.loading.set(false)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: (answer) => {
          if (answer) {
            this.userStateService.logout().subscribe();
          }
        },
        error: (error) => {
          console!.error(error);
        },
      });
  }

  onLogin(e: Event) {
    this.loading.set(true);
    this.userStateService.gotoLogin();
  }

  onToggleSidenav(e: Event) {
    this.sidenavService.toggle();
  }
}
